import { render } from "./Auth.vue?vue&type=template&id=1ab406be&ts=true&lang=pug"
import script from "./Auth.vue?vue&type=script&lang=ts&setup=true"
export * from "./Auth.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__